// extracted by mini-css-extract-plugin
module.exports = {"notification":"_1ibaV","notification-wrapper":"_1jUQ2","notificationWrapper":"_1jUQ2","tooltip":"_2h6TR"};